// extracted by mini-css-extract-plugin
module.exports = {"container":"_m1UBIWcD"};